// src/app/auth.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service'; // Import the AuthService
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  public fullUrl: string = '';
  
 
  constructor(private authService: AuthService, private router: Router,private route: ActivatedRoute) {}

  // Implement the canActivate method to check if the user is authenticated
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {




    // if (this.authService.isAuthenticated()) {
    if (true) {
     
    if (this.authService.isAuthenticated()) {
  
    
      this.fullUrl = window.location.href;
      // if(this.fullUrl.includes('/audit') &&  this.authService.currentUserValue.roleId == 9){
      //   this.router.navigate(['/starter']);
      //   return true;
      // }
      return true; // User is authenticated
      
    } else {
      this.router.navigate(['/login']); // Redirect to login if not authenticated
      return false;
    }
    
  }

}
}